import React, { useEffect } from "react";
import {
  useDisclosure,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  Box,
  DrawerBody,
  DrawerCloseButton,
  Button,
} from "@chakra-ui/react";
import { StudentForm } from "../../types";

const StudentFormDrawerLayout = ({
  children,
  setToggleDrawer,
  toggleDrawer,
  handleSubmit,
  loading,
}: {
  children: React.ReactNode;
  setToggleDrawer: (type: "add" | "update", triggered: boolean) => void;
  toggleDrawer: boolean;
  handleSubmit: () => { isInvalid: boolean } | StudentForm;
  loading: boolean;
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  useEffect(() => {
    if (toggleDrawer) {
      onOpen();
    } else {
      onClose();
    }
  }, [toggleDrawer]);

  return (
    <Drawer
      isOpen={isOpen}
      placement="right"
      onClose={() => setToggleDrawer("add", false)}
      closeOnOverlayClick={false}
    >
      <DrawerOverlay />
      <DrawerContent minW={["250px", "450px"]}>
        <DrawerCloseButton />
        <DrawerBody mt="2.5rem" px={["1rem", "1.5rem"]}>
          {children}
        </DrawerBody>
        <Box
          my="2rem"
          display={"flex"}
          justifyContent="space-between"
          alignItems={"center"}
          px={["1rem", "1.5rem"]}
        >
          <Button
            colorScheme={"red"}
            onClick={() => setToggleDrawer("add", false)}
          >
            Cancel
          </Button>
          <Button
            colorScheme={"green"}
            onClick={handleSubmit}
            isLoading={loading}
            loadingText="Saving"
            type="submit"
          >
            Save
          </Button>
        </Box>
      </DrawerContent>
    </Drawer>
  );
};

export default StudentFormDrawerLayout;
